<script lang="ts">
	interface Props {
		margin?: string
		height?: string
		color?: string
	}

	let { margin = "0", height = "2rem", color = "white" }: Props = $props()
</script>

<span
	class="loader"
	style="margin: {margin}; height: {height}; width: {height}; border-color: {color}; border-bottom-color: transparent; "
></span>

<style>
	.loader {
		aspect-ratio: 1/1;
		height: auto;
		border: 2px solid var(--color-text-light);
		border-bottom-color: transparent;
		border-radius: 50%;
		display: inline-block;
		box-sizing: border-box;
		animation: rotation 1s linear infinite;
	}

	@keyframes rotation {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>
